module.exports = __webpack_public_path__ + "static/Footpad_v3-d051e8f73174012ecbe52ff2bceda0fa.jpg";